import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/borders.css';
import { i18nReady } from './i18n';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wait for i18n translations to load before rendering
i18nReady.then(() => {
  root.render(<App />);
});
